/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Deal_Highlight_LabelInputs */

const en_directory_promotion_placements_deal_highlight_label = /** @type {(inputs: Directory_Promotion_Placements_Deal_Highlight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal highlight`)
};

const zh_directory_promotion_placements_deal_highlight_label = /** @type {(inputs: Directory_Promotion_Placements_Deal_Highlight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优惠高亮`)
};

/**
* | output |
* | --- |
* | "Deal highlight" |
*
* @param {Directory_Promotion_Placements_Deal_Highlight_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_deal_highlight_label = /** @type {((inputs?: Directory_Promotion_Placements_Deal_Highlight_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Deal_Highlight_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_deal_highlight_label(inputs)
	return zh_directory_promotion_placements_deal_highlight_label(inputs)
});
export { directory_promotion_placements_deal_highlight_label as "directory.promotion.placements.deal-highlight.label" }